import { render, staticRenderFns } from "./VisitaList.vue?vue&type=template&id=6a2d1707"
import script from "./VisitaList.vue?vue&type=script&lang=js"
export * from "./VisitaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports